import { createContext } from 'react';

const ShowsContext = createContext();

export default ShowsContext;
